import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Button, Input, Card, CardBody } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, ENUM_CURRENCY_SETTING_VAL, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";

const PacketInformationReport = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { compCode,CurrencySetting } = useSelector((state) => state.company);
    const [lotNo, setLotNo] = useState("")
    const [pktNo, setPktNo] = useState("")
    const [pktData, setPktData] = useState([])

    // Fetch  data
    const {
        data = [],
        isPending,
        isError,
        mutate: filterData,
    } = usePost({
        url: apiRoute.stockEntry.fetchPacketInfo,
        queryKey: "fetchPacketInfo",
        onSuccessTasks: (data) => {
            if (data && Object.keys(data).length > 0) {
                setPktData(data.pktData)
            }

        }
    });

    const funLoadData = () => {
        filterData({
            data: {
                comp_code: compCode.join(","), lot_no: lotNo, pkt_no: pktNo, trade_of: 'P'
            }
        })
    }
    // useEffect(() => {
    //     funLoadData();
    // }, [])

    const exportColumns = [
        {
            name: "Entry Type",
            uid: "EntryType",
        },
        {
            name: "Party NAME",
            uid: "PartyName",
        },

        {
            name: "Weight",
            uid: "Weight",
            type:COLUMN_TYPE.number
        },
        {
            name: "Rate",
            uid: "Rate",
            type:COLUMN_TYPE.number
        },

        {
            name: "Rate ($)",
            uid: "RateD",
            type:COLUMN_TYPE.number
        },
        {
            name: "Date",
            uid: "EDate",
            type: COLUMN_TYPE.date
        },


    ]
    const [exportCols, setExportCols] = useState(exportColumns)

    let downloadDataFooter = {
        EntryType: "",
        PartyName: "",
        Weight: "",
        Rate: "",
        RateD: "",
        EDate: "",
    }
    const [exportFooter, setExportFooter] = useState(downloadDataFooter)
    const INITIAL_VISIBLE_COLUMNS = ["EntryType", "PartyName", "Weight", "Rate", "RateD", "EDate"]
    const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)
    const columns = [
        { name: "Entry Type", uid: "EntryType", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Party Name", uid: "PartyName", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Weight", uid: "Weight", sortable: true, align: COLUMN_ALIGN_TYPE.center, type: COLUMN_TYPE.number },
        { name: "Rate", uid: "Rate", sortable: true, align: COLUMN_ALIGN_TYPE.center, type: COLUMN_TYPE.number },
        { name: "Rate ($)", uid: "RateD", sortable: true, align: COLUMN_ALIGN_TYPE.center, type: COLUMN_TYPE.number },
        { name: "Date", uid: "EDate", sortable: true, align: COLUMN_ALIGN_TYPE.center, type: COLUMN_TYPE.date },
    ];

    const handleFilter = (e) => {
        e.preventDefault()
        funLoadData()
    }
    useEffect(() => {
        if (CurrencySetting && CurrencySetting != "") {
            let AmtColumn = ""
            if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS)
                AmtColumn = "RateD"
            else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
                AmtColumn = "Rate"
            else {
                setInitialColumn(INITIAL_VISIBLE_COLUMNS)
                setExportCols(exportColumns)
                setExportFooter(downloadDataFooter)
            }

            if (AmtColumn != "") {
                const filterIniCol = initialColumn.filter(ele => ele != AmtColumn)
                const filterExpCol = exportColumns.filter((ele) => ele.uid != AmtColumn)
                //let footerCol = AmtColumn == 'NetAmtD' ? 'Amount$' : 'Amount'
                
                const filterExpFooter = Object.keys(downloadDataFooter).filter((ele) => ele != AmtColumn)
                setExportCols(filterExpCol)
                setInitialColumn(filterIniCol)
                setExportFooter(filterExpFooter)
            }
        }
    }, [CurrencySetting])
    
    const tdinfo = 'px-2 py-1 bg-lime-50 text-lime-700 border-b-2 border-white'
    const tdhead = 'px-2 py-1 font-semibold bg-blue-50 border-b-2 border-white text-gray-600'
    if (isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <div>
            <MainContainer pageName="Packet Information" breadcrumbs={["Reports & view", "Packet Information"]}>
                <Card shadow="sm" radius="sm" className="mb-3 h-full">
                    <CardBody className="p-2">
                        <form onSubmit={handleFilter} >
                            <div className="flex  items-center gap-2">
                                {/* date */}

                                <Input type="text" isRequired className=""
                                    classNames={{ label: "font-bold text-xs uppercase" }}
                                    variant="underlined" label="lot No" onChange={(e) => setLotNo(e.target.value)} value={lotNo}></Input>
                                <Input type="text" isRequired className=""
                                    classNames={{ label: "font-bold text-xs uppercase" }}
                                    variant="underlined" label="Packet No" onChange={(e) => setPktNo(e.target.value)} value={pktNo}></Input>
                                <Button
                                    size="sm"
                                    color="primary"
                                    startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                                    // onPress={handleFilter}
                                    type="submit"
                                    className="w-full bg-blue-800 font-semibold"
                                //isLoading={isPending}
                                >
                                    Find Info
                                </Button>

                            </div>
                        </form>
                        {
                            data && Object.keys(data).length > 0 && data?.stkData ? <div>
                                {
                                    data?.stkData.map((ele) => {
                                        return (
                                            <table className="w-full  uppercase font-semibold  mt-2 border border-red-200 rounded-md overflow-hidden text-sm">
                                                <tbody>
                                                    <tr className="">
                                                        <td className={tdhead}>Item :</td>
                                                        <td className={tdinfo}>{ele.ItemName}</td>
                                                        <td className={tdhead}>Shape :</td>
                                                        <td className={tdinfo}>{ele.ShapeName}</td>
                                                        <td className={tdhead}>Size :</td>
                                                        <td className={tdinfo}>{ele.BWeight}</td>
                                                        <td className={tdhead}>Rate :</td>
                                                        <td className={tdinfo}>{ele.BRate > 0 ? ele.BRate.toFixed(2) : ""}
                                                            {ele.BRated > 0 ? " | $" + ele.BRated.toFixed(2) : ""}
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className={tdhead}>Location :</td>
                                                        <td className={tdinfo}>{ele.StkAtName}</td>
                                                        <td className={tdhead}>Color :</td>
                                                        <td className={tdinfo}>{ele.ColorName}</td>
                                                        <td className={tdhead}>Purity :</td>
                                                        <td className={tdinfo}>{ele.PurityName}</td>
                                                        <td className={tdhead}>Lab :</td>
                                                        <td className={tdinfo}>{ele.LabName}</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        )
                                    })
                                }
                            </div> : ""
                        }
                    </CardBody>
                </Card>

                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={initialColumn}
                    data={pktData}
                    columns={columns}
                    //rowActionBtn={}
                    downloadFileName="Packet-Information"
                    exportColumns={exportCols}
                    downloadDataFooter={exportFooter}
                    showAdvanceFilter={false}
                //id=""

                />
            </MainContainer>


        </div>
    );
};

export default PacketInformationReport;
